import { cn } from '@/lib/utils';

function useModifierSymbol(): string {
  return navigator.platform.includes('Mac') ? '\u2318' : 'Ctrl';
}

export function CommandPaletteTrigger({
  className,
}: {
  className?: string;
}) {
  const mod = useModifierSymbol();

  return (
    <span
      className={cn(
        'flex items-center gap-0.5 text-xs text-muted-foreground',
        className,
      )}
    >
      <kbd className="px-1.5 py-0.5 bg-muted rounded text-[10px] font-mono">
        {mod}
      </kbd>
      <kbd className="px-1.5 py-0.5 bg-muted rounded text-[10px] font-mono">
        K
      </kbd>
    </span>
  );
}
